import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import getDomainPrices from "../services/PriceDomain.js";
import calculatePriceDetails from "../services/calculatePriceDetails.js";
import { addResumenData, removeResumenData, setIdResumen } from "../globalslice.js";
import useIsVisible from "./hooks/useIsVisible.js";
import "../helpers/NBXCookies.js";

const CartCookies = () => {
  const { ResumenData, idResumen, currency } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const isVisible = useIsVisible();

  useEffect(() => {
    const totalCount = async () => {
      // borramos todos los dominios agregados en cookies
      window.NBXDomainInCart.deleteAll();

      // filtramos los items del carrito (sin contar con bandera actual)
      const itemsCart = await ResumenData.filter((item) => {
        const isActual = item.actual;
        // si es un dominio agregado al carrito
        if (!isActual && item.type === "domain" && item?.product?.domain_section[0]?.dominio_principal) {
          const domain = item?.product?.domain_section[0]?.dominio_principal;
          const type = item?.product?.domain_section[0]?.domain_type;
          const periodo = parseInt(String(item.periodo).match(/\d+/)[0], 10);
          // agregamos dominio a las cookies
          window.NBXDomainInCart.add(domain, type, periodo);
        }

        return !isActual;
      });

      window.NBXCartCount.add(itemsCart.length);
    };

    if (typeof window.NBXCartCount !== "undefined" && typeof window.NBXDomainInCart !== "undefined") {
      totalCount();
    }
  }, [ResumenData]);

  useEffect(() => {
    const abortController = new AbortController();

    const updateDomainsCookies = async () => {
      const dominiosCarrito = await ResumenData.filter((item) => item.type === "domain" && item?.product?.domain_section[0]?.dominio_principal);
      const arrayDominiosCarrito = await dominiosCarrito.map((item) => item.product.domain_section[0].dominio_principal);

      const dominiosCookie = window.NBXDomain.getAll();
      const dominiosDeletedCookie = window.NBXDeletedDomain.getAll();
      let idResumenLocal = idResumen + 1;

      // agregamos lo nuevos dominios al carrito
      await dominiosCookie.forEach(async (item) => {
        // validamos que el dominio no exista en el carrito actual
        if (!arrayDominiosCarrito.includes(item.domain)) {
          const domainPriceSin = await getDomainPrices(
            { domain: item.domain, currency, type: "solo", typeDomainRegister: item.type },
            abortController.signal
          );

          // validamos que se halla tenido una respuesta correcta en los precios de dominio
          if (domainPriceSin) {
            let privacyCost = null;
            let privacy = null;
            const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPriceSin, domainPriceSin, parseInt(item.years));

            if (domainPriceSin?.protection[0]?.protectionid === true) {
              privacy = domainPriceSin.protection[0].protectionid;
              privacyCost = domainPriceSin.protection[0].protectionprice;
            }

            // agregar item
            dispatch(
              addResumenData({
                product: {
                  name: "Registro de Dominio",
                  smallname: "Registro de Dominio",
                  description: ``,
                  domain_section: [
                    {
                      dominio_principal: item.domain,
                      domain_type: item.type,
                    },
                  ],
                  ...(privacy && { privacy_protection: false }),
                },
                price: {
                  cost: newPrice.cost,
                  second_price: newPrice.second_price,
                  cross_price: newPrice.cross_price,
                  ...(privacyCost && { privacy_cost: privacyCost }),
                  ...(privacyCost && { privacy_period: "1 año (s)" }),
                  ...(privacyCost && { default_privacy_cost: privacyCost }),
                },
                periodo: item.years + " año (s)",
                id: idResumenLocal,
                actual: false,
                type: "domain",
                selectPeriods: selectPeriods,
                selectPeriodsWithout: selectPeriodsWithout,
              })
            );

            idResumenLocal++;
            dispatch(setIdResumen(idResumenLocal));
            // eliminamos el dominio de las cookies
            window.NBXDomain.delete(item.domain);
          }
        }
      });

      // eliminamos los dominios que se hayan eliminado desde neubox.com
      await dominiosDeletedCookie.forEach(async (item) => {
        const domain = await dominiosCarrito.filter((cart) => cart?.product?.domain_section[0]?.dominio_principal === item.domain);

        // si el dominio que se elimino desde neubox.com se encuentra en los agregados
        if (domain.length > 0) {
          const id = domain[0]?.id;
          dispatch(removeResumenData(id));
        }

        // se elimina de las cookies
        window.NBXDeletedDomain.delete(item.domain);
      });
    };

    // cuando la pestaña del carrito se hace visible, y que la instancia de NBXDomain exista en windows
    if (isVisible && typeof window.NBXDomain !== "undefined" && window.NBXDeletedDomain !== "undefined") {
      updateDomainsCookies();
    }

    return () => {
      abortController.abort();
    };
  }, [isVisible, dispatch]);

  return null;
};

export default CartCookies;
